
// Store API URL as global var in vue app
let apiUrl = '/apis'
if (['http://127.0.0.1:8080', 'http://localhost:8080'].includes(window.location.origin)) {
  apiUrl = 'http://127.0.0.1:5000/apis'
  console.log('Running locally -> apiUrl: ' + apiUrl)
}

export default apiUrl